/**
 * Zahlen lesen und schreiben — aus `zeilenblock.tsx` hierher gezogen (AP-36 B),
 * damit der Baustein in `lib/` sie ohne Querimport aus einem Feature nutzt.
 */

/** Deutsch oder Englisch, Komma oder Punkt — leer heißt `null`. */
export function leseZahl(s: string): number | null {
  const t = s.trim().replace(/\s/g, '')
  if (t === '') return null
  const n = Number(t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t)
  return Number.isFinite(n) ? n : null
}

export function zahlText(n: number | null | undefined, stellen = 3): string {
  return n === null || n === undefined ? '' : n.toLocaleString(navigator.language, { maximumFractionDigits: stellen, useGrouping: false })
}
